// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"963d4b79","453":"41527925","667":"6085d95c"}[chunkId] + ".chunk.js";
};